'use client'

import { Button } from '@/components/ui/button'
import { COOKIE_CONSENT_NAME } from '@/lib/constants'
import { useI18n } from '@/lib/i18n'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export function CookieBanner() {
  const { t } = useI18n()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_NAME)
    if (!consent) {
      setIsVisible(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_NAME, 'accepted')
    setIsVisible(false)
  }

  const handleReject = () => {
    localStorage.setItem(COOKIE_CONSENT_NAME, 'rejected')
    setIsVisible(false)
  }

  if (!isVisible)
    return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 duration-500 animate-in fade-in slide-in-from-bottom-full">
      <div className="mx-auto max-w-7xl">
        <div className="rounded-lg border border-slate-700 bg-slate-900/95 p-6 shadow-xl backdrop-blur-sm sm:flex sm:items-center sm:justify-between sm:gap-4">
          <div className="flex-1 text-sm text-slate-300">
            <p>
              {t('common.cookieBanner.description1')}{' '}
              <Link to="/legal/cookies" className="font-medium text-white underline decoration-slate-500 underline-offset-4 hover:decoration-white">
                {t('common.cookieBanner.cookiePolicy')}
              </Link>{' '}
              {t('common.cookieBanner.description2')}{' '}
              <Link to="/legal/privacy" className="font-medium text-white underline decoration-slate-500 underline-offset-4 hover:decoration-white">
                {t('common.cookieBanner.privacyPolicy')}
              </Link>{' '}
              {t('common.cookieBanner.description3')}
            </p>
          </div>
          <div className="mt-4 flex flex-col gap-2 sm:mt-0 sm:flex-row sm:items-center">
            <Button
              variant="ghost"
              size="sm"
              className="text-slate-300 hover:bg-slate-800 hover:text-white"
              onClick={handleReject}
            >
              {t('common.cookieBanner.reject')}
            </Button>
            <Button
              variant="default"
              size="sm"
              className="bg-white !text-slate-900 hover:bg-slate-200"
              onClick={handleAccept}
            >
              {t('common.cookieBanner.accept')} <span className="ml-1">→</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
